var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "wrap"
  }, [_c("div", {}, [_c("template-content", {
    ref: "editor",
    attrs: {
      id: _vm.id,
      "task-id": _vm.taskId,
      "is-in-correspondence": _vm.isInCorrespondence,
      params: _vm.list,
      "confirm-id": _vm.confirmId,
      "tool-fixed": false,
      "param-list-loading": _vm.paramLoading,
      "update-param": _vm.updateParam,
      "get-subject-options": _vm.getSubjectOptions,
      "get-param-detail": _vm.getParamDetail,
      "remove-param": _vm.removeParam,
      "create-param": _vm.createParam,
      "default-editor-val": _vm.isPreView ? _vm.previewData : _vm.currentValue,
      "is-pre-view": _vm.isPreView,
      "only-read": _vm.onlyRead
    },
    on: {
      paramsChange: _vm.paramsChange
    },
    model: {
      value: _vm.form,
      callback: function callback($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, [_vm.confirmId ? _c("cpsc-auto-pagination", {
    attrs: {
      slot: "pagination",
      "current-page": _vm.currentPage,
      total: _vm.totalPages,
      "page-size": _vm.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function updateCurrentPage($event) {
        _vm.currentPage = $event;
      },
      "update:current-page": function updateCurrentPage($event) {
        _vm.currentPage = $event;
      }
    },
    slot: "pagination"
  }) : _vm._e()], 1)], 1), _c("div", {
    staticClass: "dialog-btn-wrap"
  }, [_vm.isPreView ? [_c("el-button", {
    attrs: {
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: function click($event) {
        _vm.isPreView = false;
      }
    }
  }, [_vm._v("返回")])] : [!_vm.onlyRead ? _c("el-button", {
    attrs: {
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.cancel
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm.canBePreView ? _c("el-button", {
    attrs: {
      type: "info",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.toView
    }
  }, [_vm._v("预览")]) : _vm._e(), !_vm.onlyRead ? _c("el-button", {
    attrs: {
      type: "primary",
      size: "mini",
      loading: _vm.loading
    },
    on: {
      click: _vm.submit
    }
  }, [_vm._v("确定")]) : _vm._e()]], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };